<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="3" sm="12">
        <v-text-field v-model="queryForm.text" outlined dense label="车牌号/挂厢号"></v-text-field>
      </v-col>
      <v-col cols="12" xl="10" lg="10" md="9" sm="12">
        <v-row>
          <v-col cols="12" xl="2" lg="2" md="6" sm="6">
            <v-autocomplete v-model="queryForm.vehicle_type" :items="vehicle_types" label="车辆吨位"
              :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xl="2" lg="2" md="6" sm="6">
            <v-autocomplete v-model="queryForm.type" :items="types" label="车辆类型"
              :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xl="2" lg="2" md="6" sm="6">
            <v-autocomplete v-model="queryForm.driverid" :items="drivers" label="选择司机"
              :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xl="2" lg="2" md="6" sm="6">
            <a-space>
              <v-btn color="primary" tile style="color:#fff;" @click="getdata">
                <v-icon small>mdi-magnify</v-icon> 查询
              </v-btn>
              <v-btn color="success" tile @click="showadd">
                <v-icon small>mdi-plus</v-icon> 新增车辆
              </v-btn>
              <UploadTask btnText="导入车辆" btnColor="cyan" modelTitle="导入车辆"
                :alertText="`上传Excel文件需包含 <span class='error--text'>类型</span>、<span class='error--text'>车牌号</span>、<span>挂箱号</span>、<span class='error--text'>原车牌号</span>、<span class='error--text'>车辆类型</span>、<span>车辆容积</span>、<span class='error--text'>所属类型</span>、<span>电池容量</span> 字段。类型：<span class='error--text'>车头、挂箱、整车</span>，车辆类型：<span class='error--text'>5吨、8吨、12吨、20吨、30吨、40吨</span>，所属类型：<span class='error--text'>自有车、临调、包车</span>。`"
                uploadType="vehiclevehicle" />
            </a-space>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.own_type" size="small" @change="(v) => getdata()">
      <a-tab-pane :key="0" tab="全部"></a-tab-pane>
      <a-tab-pane :key="1" tab="自有车"></a-tab-pane>
      <a-tab-pane :key="3" tab="包车"></a-tab-pane>
      <a-tab-pane :key="2" tab="临调车"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center pl-2">
              <span>共 {{ length }} 页 / {{ count }} 条数据</span>
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                    {{ limit }}/页
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                    <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <a-space>
              <v-btn v-if="need_maintenance_count > 0" color="error" tile @click="getdata('need_maintenance')">
                待维护车辆{{ need_maintenance_count }}
              </v-btn>
              <v-btn v-if="username === 'root'" color="error" tile @click="getdata('empty')">
                带空格
              </v-btn>
            </a-space>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="type" slot-scope="text, record">
          <v-chip v-if="record.type === 1" label outlined small color="error">车头</v-chip>
          <v-chip v-if="record.type === 2" label outlined small color="orange">挂箱</v-chip>
          <v-chip v-if="record.type === 3" label outlined small color="cyan">整车</v-chip>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <p><span>{{ record.vehicle_number }} {{ record.vehicle_gnumber }}</span></p>
          <p class="error--text">{{ record.vehicle_onumber }}</p>
        </template>
        <template slot="own_type" slot-scope="text, record">
          <p v-if="record.own_type === 1">自有车</p>
          <p v-if="record.own_type === 2">临调</p>
          <p v-if="record.own_type === 3">包车</p>
        </template>
        <template slot="location" slot-scope="text, record">
          <p>{{ record.location.title }}</p>
          <p>{{ record.location.address }}</p>
          <p v-if="record.location.longitude">{{ record.location.longitude }},{{ record.location.latitude }}</p>
          <p v-if="record.locationTime" class="error--text">{{ record.locationTime }}</p>
          <v-btn v-if="username === 'root'" icon @click="refreshlocation(record._id)">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <template slot="state_name" slot-scope="text, record">
          <p>{{ record.vehicle_number }}</p>
          <p style="color: red;">{{ record.vehicle_onumber }}</p>
        </template>

        <template slot="state" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span :style="{ color: record.state_color, }">{{ record.state_name }}</span>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => changeState(record._id, e.key)">
              <template v-for="item of vehiclestates">
                <a-menu-item v-if="record.state !== item.value" :key="item.value">
                  <a href="javascript:;">{{ item.text }}</a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="driverid" slot-scope="text, record">
          <v-autocomplete v-model="record.driverid" :items="drivers" label="绑定司机"
            :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details
            @change="(v) => changeDriver(record._id, v)">
          </v-autocomplete>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除车辆" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="580px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="form.type" :items="types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" v-if="form.type === 1">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 2">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      挂箱号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 3">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 1 || form.type === 3">
                  <v-text-field v-model="form.vehicle_onumber" outlined dense>
                    <template v-slot:label>
                      原车牌号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 3">
                  <v-text-field v-model="form.vehicle_gnumber" outlined dense>
                    <template v-slot:label>
                      挂箱号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 2">
                  <v-autocomplete v-model="form.vehicle_gtype" :items="vehicle_gtypes" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      挂箱类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.vehicle_type" :items="vehicle_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      车辆类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.own_type" :items="own_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      所属类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.driverid" :items="drivers" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" outlined dense clearable>
                    <template v-slot:label>
                      绑定司机
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <ChooseLocation ref="mapRef" @on-location-confirmed="confirmLocation" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import ChooseLocation from "@/components/chooselocation.vue";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "VehicleDrawHead",
  data() {
    return {
      queryForm: {
        own_type: 0,
        text: "",
        vehicle_type: null,
        type: null,
        teamid: null,
        driverid: null,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 60, align: "center" },
        { title: "类型", dataIndex: "type", scopedSlots: { customRender: "type" }, width: 100, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 100, align: "center" },
        { title: "车辆类型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 100, align: "center" },
        { title: "当前司机", dataIndex: "driverid", scopedSlots: { customRender: "driverid" }, width: 150, align: "center" },
        // { title: "车辆容积", dataIndex: "vehicle_volume", scopedSlots: { customRender: "vehicle_volume" }, width: 100, align: "center" },
        // { title: "成本费用(元/月)", dataIndex: "fee", scopedSlots: { customRender: "fee" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "所属类型", dataIndex: "own_type", scopedSlots: { customRender: "own_type" }, width: 100, align: "center" },
        { title: "当前位置", dataIndex: "location", scopedSlots: { customRender: "location" }, width: 180, align: "center" },
        // { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 100, align: "center" },
        // { title: "所属车队", dataIndex: "teamname", scopedSlots: { customRender: "teamname" }, width: 100, align: "center" },
        { title: "更新时间", dataIndex: "optime", scopedSlots: { customRender: "optime" }, width: 150, align: "center" },
        { title: "操作人", dataIndex: "opby", scopedSlots: { customRender: "opby" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: "right" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      need_maintenance_count: 0,
      vehicle_types: [],
      vehicle_gtypes: [],
      types: [],
      own_types: [],
      teams: [],
      drivers: [],
      vehiclestates: [],
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {
        location: {},
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: { ChooseLocation, UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/list", { page: this.page, limit: this.limit, ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;//车辆类型
          this.vehicle_gtypes = res.data.vehicle_gtypes;//挂箱类型:1：单轴挂、2：双轴挂
          this.types = res.data.types;
          this.own_types = res.data.own_types;
          this.teams = res.data.teams;
          this.drivers = res.data.drivers;
          this.vehiclestates = res.data.vehiclestates;
          this.need_maintenance_count = res.data.need_maintenance_count;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        type: undefined,
        vehicle_number: "",
        vehicle_onumber: "",
        vehicle_gnumber: "",
        vehicle_type: undefined,
        vehicle_gtype: undefined,
        vehicle_volume: "",
        own_type: 0,
        battery_capacity: "",
        location: {
          title: "",
          address: "",
          latitude: "",
          longitude: "",
        },
        state: "0",
        manufacturer_name: "",
        teamid: "",
        driverid: undefined,
      };
      this.modeltitle = "新增车辆/挂箱";
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        type: item.type,
        vehicle_number: item.vehicle_number,
        vehicle_onumber: item.vehicle_onumber,
        vehicle_gnumber: item.vehicle_gnumber,
        vehicle_type: item.vehicle_type,
        vehicle_gtype: item.vehicle_gtype,
        vehicle_volume: item.vehicle_volume,
        own_type: item.own_type,
        battery_capacity: item.battery_capacity,
        location: item.location,
        state: item.state,
        teamid: item.teamid,
        manufacturer_name: item.manufacturer_name,
        driverid: item.driverid,
      };
      this.modeltitle = "编辑车辆/挂箱信息";
      this.model = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    changeState(_id, v) {
      console.log('changeState', v);
      this.update(_id, 'state', v);
    },
    changeDriver(_id, v) {
      console.log('changeDriver', v);
      this.update(_id, 'driverid', v);
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    refreshlocation(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/refreshlocation", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    chooseLocation() {
      this.$refs.mapRef.init({
        id: this.$utils.uuid(),
        open: true,
        title: "地图选点",
        form: {
          address: this.form.location.address,
        },
      });
      // let list = [];
      // if (this.form.location.latitude && this.form.location.longitude) {
      //   list.push({
      //     title: this.form.location.title || this.form.name,
      //     address: this.form.location.address,
      //     location: {
      //       lat: Number(this.form.location.latitude),
      //       lng: Number(this.form.location.longitude),
      //     },
      //   });
      // }
      // this.$nextTick(() => {
      //   this.$refs.mapRef.initMap({
      //     lat: this.form.location.latitude,
      //     lng: this.form.location.longitude,
      //     list,
      //   });
      // });
    },
    confirmLocation(data) {
      console.log('confirmLocation', data);
      this.form.location = {
        title: data.title,
        // address: data.address,
        latitude: data.location.lat,
        longitude: data.location.lng,
      };
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
